import { Map } from 'immutable';
import { SCOUT_AI } from '@constants/actions';

const initialState = Map({
  scoutAIList: [],
  selectedScoutAIList: undefined,
  scoutAIDataList: undefined,
  scoutAIResult: {},
  totalCount: null
});

const ScoutAI = (state = initialState, action) => {
  const actionPayload = action.payload;
  switch (action.type) {
    case SCOUT_AI.POPULATE_SCOUT_AIS:
      return state.set('scoutAIList', actionPayload.scoutAIs)
        .set('totalCount', actionPayload.totalCount);
    case SCOUT_AI.POPULATE_SCOUT_AIS_DATA:
      const scoutAIDataList = actionPayload.scoutAIs.reduce((acc, scout) => {
        acc[scout.guid] = scout;
        return acc;
      }, {});
      return state.set('scoutAIDataList', scoutAIDataList);
    case SCOUT_AI.POPULATE_SELECTED_SCOUT_AIS:
      return state.set('selectedScoutAIList', actionPayload.scoutAIs);
    case SCOUT_AI.RETRIEVE_SCOUT_AI_RESULT:
      return state.set('scoutAIResult', actionPayload.scoutAIResult);
    default:
      return state;
  }
};

export default ScoutAI;